module.exports = __webpack_public_path__ + "img/grey.14a174ce.svg";